// Descomentar los proebedores que sean implementados o agregar
export enum ProviderType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
  // TELEGRAM = 'TELEGRAM',
}

// Descomentar los proebedores que sean implementados o agregar
export const ProviderTypeArray: ProviderType[] = [
  // ProviderType.EMAIL,
  ProviderType.SMS,
  // ProviderType.WHATSAPP,
  // ProviderType.TELEGRAM, 
]